module.exports = __webpack_public_path__ + "img/engine.5ef8f116.jpeg";